import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { User } from '@angular/fire/auth';
import { UserService } from './user.service';
import { Profile, ProfileSettings } from '../models/profile.model';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  profile = signal<Profile>({} as Profile);

  constructor(
    private http: HttpClient,
    private userService: UserService,
  ) {}

  getProfile(): Profile {
    return this.profile();
  }

  setProfile$(profile: Profile): void {
    this.profile.set(profile);
  }

  setProfile(profile: Profile): void {
    this.profile.set(profile);
  }

  getOrCreateProfile(user: User): Observable<Profile> {
    return this.http.post<Profile>(
      `/profile`,
      this.userService.getUserPayload(user),
    );
  }

  getProfileById(profileId: string): Observable<Profile> {
    return this.http.get<Profile>(`/profile/${profileId}`);
  }

  updateProfile(
    profileId: string,
    partialProfile: Partial<Profile>,
  ): Observable<Profile> {
    return this.http.patch<Profile>(`/profile/${profileId}`, partialProfile);
  }

  deleteProfile(profileId: string): Observable<Profile> {
    return this.http.delete<Profile>(`/profile/${profileId}`);
  }

  getProfilesByUserId(userId: string): Observable<Profile[]> {
    return this.http.get<Profile[]>(`/profiles/${userId}`);
  }

  updateProfileSettings(
    profileId: string,
    partialProfile: Partial<ProfileSettings>,
  ): Observable<Profile> {
    return this.http.patch<Profile>(
      `/profile/${profileId}/settings`,
      partialProfile,
    );
  }
}
